import './Style.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import Index from './Index.jsx'

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
)
